module.exports = __webpack_public_path__ + "static/media/ph_d.398b6122.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/earlySalePopup/ph_d.png
// module id = 1712
// module chunks = 103